import { RootStore } from '~/stores/root.store';
import { IExportReportParams } from '~/components/Reports/types/reports.types';
import { ClientPendingTaskType } from '~/common/hooks/ClientPendingTask/client-pending-task.types';

export class ReportsController {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    async getExportReportsData(data: IExportReportParams) {
        const {
            userStore: { currUser },
            globalContext: { clientPendingTaskCtrl }
        } = this.rootStore;

        const result = await clientPendingTaskCtrl.performClientPendingTask({
            taskType: ClientPendingTaskType.GenerateReport,
            taskData: {
                report_type: data.report_type,
                order_by: data.order_by,
                user_id: currUser._id,
                period_from: data.period_from,
                period_to: data.period_to
            }
        });
        return result;
    }
}
